/**
 * RelaxationPlateCard — готовата „релаксираща чиния“, свързана в
 * кортизоловия модул. Данни: GET /api/stress-twin/relaxation-plate,
 * POST /api/stress-twin/relaxation-plate/log
 */
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Utensils, Loader2, Check } from "lucide-react";
import { useAuth } from "@/App";

export default function RelaxationPlateCard({ isDark = false }) {
  const { API } = useAuth();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/stress-twin/relaxation-plate`);
      setD(data);
    } catch { setD(null); }
  }, [API]);

  useEffect(() => { load(); }, [load]);
  if (!d?.plate?.foods?.length) return null;

  const logAll = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/stress-twin/relaxation-plate/log`, {});
      toast.success(`${data.logged} храни записани в дневника`);
      window.dispatchEvent(new Event("nutramilo:meals:updated"));
    } catch { toast.error("Не се записа"); } finally { setBusy(false); }
  };

  const border = isDark ? "border-white/10" : "border-slate-200";

  return (
    <div className={`rounded-2xl border p-4 ${isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200"}`}
      data-testid="relaxation-plate-card">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <span className="text-[13px] font-extrabold inline-flex items-center gap-1.5">
          <Utensils className="w-4 h-4 text-emerald-500" /> Релаксираща чиния
        </span>
        {d.detected && (
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-600"
            data-testid="relaxation-plate-trigger">
            съобразена с {d.triggers.length} засечен(и) стресор(а)
          </span>
        )}
      </div>
      {d.plate.why_bg && <div className="text-[11px] opacity-75 mt-1">{d.plate.why_bg}</div>}

      <div className="mt-3 space-y-1" data-testid="relaxation-plate-foods">
        {d.plate.foods.map((f, i) => (
          <div key={i} className={`p-2 rounded-lg border text-[11px] flex items-center justify-between gap-2 ${border}`}
            data-testid={`relaxation-plate-food-${i}`}>
            <span className="font-bold truncate">{f.food_name}</span>
            <span className="opacity-60 shrink-0">{f.amount_g} g · {f.meal_type}</span>
          </div>
        ))}
      </div>

      <button onClick={logAll} disabled={busy}
        className="mt-3 w-full px-3 py-2 rounded-xl text-[12px] font-bold text-white
                   bg-gradient-to-r from-emerald-500 to-teal-600 inline-flex items-center
                   justify-center gap-1.5 disabled:opacity-50"
        data-testid="relaxation-plate-log">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />}
        Запиши чинията в дневника
      </button>
    </div>
  );
}
